import './preauth.scss'
import utility from 'src/utils/utility'
import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { PreauthSideContent } from 'src/component'

export const PreauthRoutes = () => {
    const navigate = useNavigate()
    const [token, setToken] = useState<string|null>(null)

    useEffect(() => {
        //handleAuth()
    }, [])

    async function handleAuth () {
        let userToken = await localStorage.getItem('token')
        if (userToken) navigate('/dashboard/home')
    }
    
    return (
        <div className="preauth-container">
            <PreauthSideContent />
            <div className="preauth-modules">
                <Outlet/>
            </div>
        </div>
    )
}

export default utility.routeData('/', 'Preauth', <PreauthRoutes/>)
